module.exports = __webpack_public_path__ + "static/media/admin-tag.6fe80fb3.svg";